import { useFetchStudentsQuery } from '../services/registrationApi';

import { RegistrationData } from './RegistrationForm';

const WebsiteLeadsPage = () => {
  const { currentData } = useFetchStudentsQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );
  return (
    <div className='min-h-screen bg-white px-4 py-8'>
      <div className='mx-auto max-w-6xl'>
        <div className='mb-8 flex flex-col'>
          <h1 className='text-3xl font-bold text-gray-800'>
            Student Registrations
          </h1>
          <div className='flex items-center justify-between'>
            <div className='text-gray-600'>
              <span>
                Total Registrations -{' '}
                <span className='text-2xl font-bold text-purple-600'>
                  {currentData?.data?.length}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className='overflow-hidden rounded-xl bg-white shadow-2xl'>
          <div className='overflow-x-auto'>
            <table className='w-full'>
              <thead className='bg-primary text-white'>
                <tr>
                  <th className='px-6 py-4 text-left text-sm font-semibold'>
                    Name
                  </th>
                  <th className='px-6 py-4 text-left text-sm font-semibold'>
                    Email
                  </th>
                  <th className='px-6 py-4 text-left text-sm font-semibold'>
                    College
                  </th>
                  <th className='px-6 py-4 text-left text-sm font-semibold'>
                    Phone
                  </th>
                  <th className='px-6 py-4 text-left text-sm font-semibold'>
                    Branch
                  </th>
                  <th className='px-6 py-4 text-left text-sm font-semibold'>
                    Source
                  </th>
                </tr>
              </thead>
              <tbody className='divide-y divide-gray-200'>
                {currentData?.data?.map((reg: RegistrationData) => (
                  <tr key={reg?.id} className='transition hover:bg-purple-50'>
                    <td className='px-6 py-4 text-sm text-gray-900'>
                      {reg?.name || '-'}
                    </td>
                    <td className='px-6 py-4 text-sm text-gray-900'>
                      {reg?.emailId}
                    </td>
                    <td className='px-6 py-4 text-sm text-gray-900'>
                      {reg?.college || '-'}
                    </td>
                    <td className='px-6 py-4 text-sm text-gray-900'>
                      {reg?.phoneNumber}
                    </td>
                    <td className='px-6 py-4 text-sm text-gray-900'>
                      {reg?.branch || '-'}
                    </td>
                    <td className='px-6 py-4'>
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-medium ${
                          reg?.leadSource === 'WEBSITE'
                            ? 'bg-blue-100 text-blue-800'
                            : 'bg-green-100 text-green-800'
                        }`}
                      >
                        {reg?.leadSource}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteLeadsPage;
